export default __webpack_public_path__ + "static/media/aeroland-branding-picture-03.a69a0171.png";